import { render, staticRenderFns } from "./CheckerboardFabricCanvas.vue?vue&type=template&id=19ea5b46"
import script from "./CheckerboardFabricCanvas.vue?vue&type=script&lang=js"
export * from "./CheckerboardFabricCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports